export const SUPPLIER_NAME_ASWO = "ASWO";
export const SUPPLIER_NAME_SDS = "SDS";
export const SUPPLIER_NAME_MANUFACTURER = "CONSTRUCTEUR";
